<template>
  <div>

    <div class="sub-nav">
      <span class="sub-nav-icon">
        <i class="cubeic-back" @click="goBack"></i>
      </span>
      <span class="sub-nav-title">问答详情</span>
      <span class="sub-nav-right">回复</span>
    </div>

    <div class="container">
      <div class="law-list">
        <p>问题分类：植物识别</p>
        <p>问题描述：请问这个植物是什么啊？</p>
        <p class="img"><img src="../assets/law/p2.jpg"></p>
        <p class="over">识别结果：<span class="name">橘子</span></p>
        <div class="answer">
          <div class="title">回复</div>
          <cube-textarea v-model="value2" placeholder="请输入内容"></cube-textarea>
        </div>
        <p class="other">
          <span>回复时间：2019/10/25</span>
          <span>回复来源：孙专家</span>
        </p>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: "online-my",

    data() {
      return {
      }
    },

    methods: {
      goBack() {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      }
    },

  }
</script>

<style lang="scss" scoped>
  @import "../assets/css/base.scss";
  .container {
    background-color: #fff;
  }
  .law-list {
    padding: 15px 15px 5px 15px;
  }
  .law-list p {
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
    line-height: 22px;
  }
  .law-list p img {
    display: block;
    width: 100%;
  }
  .law-list p .name {
    font-size: 20px;
    font-weight: 600;
  }
  .law-list .other span {
    display: inline-block;
    color: #999;
    font-size: 12px;
  }
  .law-list .other span:first-child {
    margin-right: 20px;
  }
  .law-list .answer {
    margin-bottom: 10px;
  }
  .law-list .answer .title {
    font-size: 16px;
    color: #333;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/online-details.vue